import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectCurrentUser } from '@user/store/authorization'
import { useGetExternalAppName } from '@user/store/authorization/hooks/useGetExternalAppName'
import { selectAllTenantFeatures } from '@user/store/tenantFeatures'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

export const usePendoInit = () => {
  const currentUser = useSelector(selectCurrentUser)
  const externalAppName = useGetExternalAppName()
  const allFeatures = useSelector(selectAllTenantFeatures)
  useEffect(() => {
    const visitor = {
      id: currentUser.userId,
      email: currentUser.emailAddress,
      fullName: currentUser.userName,
      tenant: currentUser.tenantId,
      externalProduct: externalAppName,
      role: currentUser.roleName,
      isExternalMappedUser: currentUser.externalUserId ? true : false,
    }
    currentUser.permissions.forEach((p) => (visitor[p] = true))

    const account = {
      id: currentUser.tenantId,
      product: 'Sales Center',
      name: currentUser.companyName,
      externalProduct: externalAppName,
      feature_CampaignTracking: allFeatures.find(
        (x) => x.featureId === FEATURES.CampaignTracking,
      )?.enabled,
      feature_EntityFormSettings: true,
      feature_Estimates: allFeatures.find(
        (x) => x.featureId === FEATURES.Estimates,
      )?.enabled,
      feature_Reports: true,
      feature_UnsoldServices: true,
    }

    const pendoInit = {
      visitor: visitor,
      account: account,
    }
    // @ts-expect-error pendo is available at run time
    pendo.initialize(pendoInit)
  }, [allFeatures, currentUser, externalAppName])
}
